import { Component, Injector, Input } from '@angular/core';
import { ThemesLayoutBaseComponent } from '../themes/themes-layout-base.component';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'contact',
    templateUrl: './contact.component.html'
})
export class ContactComponent extends ThemesLayoutBaseComponent {

    @Input() textCssClass = 'text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3';

    public constructor(
        injector: Injector,
        _dateTimeService: DateTimeService
    ) {
        super(injector, _dateTimeService);
    }
}
